<template>
    <div class="modal-ServiceAdd">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">添加</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">

                <el-form :model="addForm" :rules="rules" ref="addForm">
                    <div>
                        <el-row>
                             <el-col :span="12" class="item">
                                <el-form-item label="注册账号（手机号）" required prop="phone">
                                    <el-input v-model="addForm.phone"  maxlength="11" placeholder="请输入注册账号"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="注册密码" required  prop="password">
                                    <el-input v-model="addForm.password" minlength="6" type="password" placeholder="请输入注册密码" show-password></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="姓名" required prop="name">
                                    <el-input v-model="addForm.name" placeholder="请输入服务人员姓名"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="性别" required prop="gender">
                                    <el-radio-group v-model="addForm.gender" style="width:100%">
                                        <el-radio :label="0">女</el-radio>
                                        <el-radio :label="1">男</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                </el-form>

            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('addForm')">添加</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode,getStaffDTO} from "@/utils/auth";

    export default {
        name: 'Add',
        data() {
            return {
                loading: false,
                healthCardsFileList:[],
                qualificationFileList:[],
                uploadUrl:this.$shopUrl+'Upload/Imgs',
                uploadUrl1:this.$shopUrl+'Upload/File',
                uploadData:{
                    staffCode:getStaffCode(),
                    timeStr:timeStr,
                    sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey)
                },
                qualificationImageUrl:'',
                qualificationVisible:false,
                healthCardsImageUrl:'',
                healthCardsVisible:false,
                defaultProps: {
                    children: 'listMenuDTO',
                    label: 'name'
                },
                serviceTypeValue:['兼职','专职'],
                addForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    name:'',
                    phone:'',
                    password:'',
                    gender:0,
                    businessCode:getStaffDTO().businessDTO.businessCode
                },

                rules:{
                    phone:[
                        { required: true, message: '请输入注册账号', trigger: 'blur' },
                        {
                            pattern: /^1[3456789]\d{9}$/,
                            message: '请输入正确的手机号'
                        },
                    ],
                    password:[
                        { required: true, message: '请输入注册密码', trigger: 'blur' },
                    ],
                     name:[
                        { required: true, message: '请输入姓名', trigger: 'blur' },
                    ],
                },
            }
        },

        methods: {
            init(){
                this.$refs.addForm.resetFields();
                this.img=''
            },
            qualificationRemove(file, fileList) {
                console.log(file, fileList);
                this.addForm.qualification = '';
            },
            qualificationSuccess(res, file) {
                console.log(file)
                this.addForm.qualification = this.$imgUrl+res.data.path;
            },
            qualificationPreview(file) {
                this.qualificationImageUrl = file.url;
                this.qualificationVisible = true;
            },
            healthCardsRemove(file, fileList) {
                console.log(file, fileList);
                this.addForm.healthCards = '';
            },
            healthCardsSuccess(res, file) {
                console.log(file)
                this.addForm.healthCards = this.$imgUrl+res.data.path;
            },
            healthCardsPreview(file) {
                this.healthCardsImageUrl = file.url;
                this.healthCardsVisible = true;
            },
            qualificationBefore(file){
                console.log(file.name)
                var name=file.name;
                name=name.slice(-3)
                if(name!='jpg'&&name!='peg'&&name!='png'&&name!='JPG'&&name!='PNG'&&name!='JPEG'){
                    this.$message({type: 'info', message: '请上传jpg/jpeg/png格式的图片'});
                    // this.qualificationFileList=[]
                    return false;
                }
            },
            healthCardsBefore(file){
                console.log(file.name)
                var name=file.name;
                name=name.slice(-3)
                if(name!='jpg'&&name!='peg'&&name!='png'&&name!='JPG'&&name!='PNG'&&name!='JPEG'){
                    this.$message({type: 'info', message: '请上传jpg/jpeg/png格式的图片'});
                    // this.healthCardsFileList=[]
                    return false;
                }
            },
            closeSelf() {
                this.$emit("closeAdd");
                this.loading = false;
            },
             handleImgSuccess(res, file) {
                 console.log(file)
                this.addForm.img = this.$imgUrl+res.data.path;
            },
            confirm(addForm){
                this.$refs[addForm].validate((valid) => {
                    if(valid){
                        this.addSubmit();
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })

            },

            addSubmit(){

                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }
                this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Cashier/Add",
                    data: this.addForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$emit("closeAdd");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                    }
                )
            },


        }
    }


</script>





<style lang="scss" scoped>

    .modal-ServiceAdd {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:  0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 700px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body .avatar-uploader .el-upload {
                border: 1px dashed #d9d9d9;
                border-radius: 6px;
                cursor: pointer;
                position: relative;
                overflow: hidden;
                width:100px;
                height: 100px;
            }
            .modal-body .avatar-uploader .el-upload:hover {
                border-color: #409EFF;
            }
            .modal-body .avatar-uploader-icon {
                font-size: 28px;
                color: #8c939d;
                width: 100px;
                height: 100px;
                line-height: 100px;
                text-align: center;
            }
            .modal-body .avatar {
                width: 100px;
                height: 100px;
                display: block;
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                overflow-y:auto;
                height: 300px;
            }
            .upload-demo{
                margin-top: 40px;
            }
            .modal-body /deep/ .el-upload--picture-card{
                width: 100px;
                height: 100px;
                line-height: 100px;
            }
            .modal-body /deep/ .el-upload--picture {
                display: inline;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
